// 主聊天窗口仅保留近期消息；完整记录仍通过聊天记录接口分页查询。
export const MAX_CACHED_MESSAGES_PER_CONVERSATION = 500
// 限制仅存放消息正文的会话数量，会话摘要和未读数不受影响。
export const MAX_CACHED_MESSAGE_CONVERSATIONS = 50
